/**
 * Created by zhangrp on 2018/4/3.
 */

import {MsgBox, Vue} from '../../app.vues';

import SwbShopDeviceScrapVoucherAudit from './ShopDeviceScrapVoucherAudit';

Vue.regist(SwbShopDeviceScrapVoucherAudit);

// 通用资产业务单据审核页面
export function openShopDeviceScrapVoucherAuditDlg(callback, title, id) {
    Vue.$showDialog({
        title: title == null ? '资产报废单 - 审核' : title,
        width: 500,
        height: 400,
        showCloseBtn: true,
        template: '<swb-shop-device-scrap-audit :id="id" ref="swb_shop_device_scrap_audit"></swb-shop-device-scrap-audit>',
        data: {
            id: id
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_shop_device_scrap_audit.getDlgResult() || {};
            if (result.type === 'info') {
                let resultDate = result.data;
                callback(resultDate);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}


import SwbScrapVoucherAudit from './AssetVoucherAudit';
Vue.regist(SwbScrapVoucherAudit);

// 通用资产业务单据审核页面
export function openAssetVoucherAuditDlg(callback, title) {
    Vue.$showDialog({
        title: title == null ? '资产报废单 - 审核' : title,
        width: 500,
        height: 400,
        showCloseBtn: true,
        template: '<swb-asset-voucher-audit ref="swb_asset_voucher_audit"></swb-asset-voucher-audit>',
        data: {},
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_asset_voucher_audit.getDlgResult() || {};
            if (result.type === 'info') {
                let resultDate = result.data;
                callback(resultDate);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// wangyz
import SwbShopDeviceScrapItemView from './ShopDeviceScrapItemView';

Vue.regist(SwbShopDeviceScrapItemView);

//审核报废 - 审核是修改资产信息
export function openShopDeviceScrapItemViewDlg(callback, title, id, oldScrapVoucher) {
    Vue.$showDialog({
        title: title == null ? '资产信息 - 编辑' : title,
        width: 1300,
        height: 800,
        showCloseBtn: true,
        template: '<swb-shop-device-scrap-item-view :id="id" :oldScrapVoucher="oldScrapVoucher" ref="swb_shop_device_scrap_item_view"></swb-shop-device-scrap-item-view>',
        data: {
            id: id,
            oldScrapVoucher: oldScrapVoucher
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_shop_device_scrap_item_view.getDlgResult() || {};
            if (result.type === 'info') {
                let resultDate = result.data;
                callback(resultDate);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbScrapVoucherImpCheck from './ScrapVoucherImpCheck';
Vue.regist(SwbScrapVoucherImpCheck);
//
export function openScrapVoucherImpCheckDlg(fileExtra, callback) {
    let theDlg = Vue.$showDialog({
        title: "报废单据业务导入",
        height: 800,
        width: -400,
        showCloseBtn: true,
        cancelText: '关闭',
        okVisible: false,
        template: '<swb-shop-devc-scrap-voucher-imp-check  @other-close="otherClose" :fileExtra="fileExtra" ref="swb_shop_devc_scrap_voucher_imp_check"></swb-shop-devc-scrap-voucher-imp-check>',
        data: {
            fileExtra: fileExtra,
        },
        methods: {
            otherClose(result){
                theDlg.close();
                callback();
            }
        },
        okClicked: function () {

        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/scrapVoucher/selectDlg.js
// module id = 93
// module chunks = 0